import bytes from 'bytes'

export function fileSizeFormat(value: number, precision: number = 1): string {
  if (!isFinite(value) || value < 0) {
    return '-'
  }
  return bytes.format(value, { decimalPlaces: precision })
}
